<template>
  <v-container fluid class="pa-0" style="height: 100%; max-height: 100%;">
    <v-row no-gutters style="height: 100%;">
      <v-col
        cols="12"
        md="2"
        xl="1"
        class="overflow-y-auto pa-2"
        :style="$vuetify.breakpoint.mdAndUp ? 'height: calc(100vh - 112px);' : ''"
      >
        <v-tabs
          v-model="selectedItem"
          :vertical="$vuetify.breakpoint.mdAndUp"
          :show-arrows="$vuetify.breakpoint.smAndDown"
        >
          <v-tab
            v-for="tab in tabItems"
            :key="tab.code"
            :href="`#${tab.code}`"
            class="px-md-12 justify-start"
            :disabled="modeSettingSaving"
          >
            {{ tab.name }}
          </v-tab>
        </v-tabs>
      </v-col>

      <v-col
        cols="12"
        md="10"
        xl="11"
        class="pt-1"
      >
        <v-card
          flat
          class="overflow-y-auto px-md-6"
          :height="$vuetify.breakpoint.mdAndUp ? 'calc(100vh - 116px)' : 'calc(100vh - 180px)'"
          :max-height="$vuetify.breakpoint.mdAndUp ? 'calc(100vh - 116px)' : 'calc(100vh - 180px)'"
          color="grey-8"
        >
          <v-card
            flat
            max-width="1680"
            class="px-md-6"
            color="grey-8"
          >
            <div
              :class="{'mt-3': $vuetify.breakpoint.mdAndUp}"
            >
              <div class="d-flex flex-wrap">
                <div :style="$vuetify.breakpoint.mdAndUp ? 'width: auto; max-width: 68%;' : 'width: 100%;'">
                  <guide-tour config-key="onlineAppointmentSetting"/>
                </div>
                <v-spacer/>
<!--                <div-->
<!--                  class="d-flex align-center px-4"-->
<!--                  :style="$vuetify.breakpoint.mdAndUp ? 'width: auto;' : 'width: 100%;'"-->
<!--                  :class="{'pb-3': $vuetify.breakpoint.smAndDown}"-->
<!--                >-->
<!--                  <v-btn-->
<!--                    v-if="selectedItem"-->
<!--                    :href="websiteUrl()"-->
<!--                    target="_blank"-->
<!--                    block-->
<!--                    color="primary"-->
<!--                  >{{ clinicUser ? '查看診所目前預約網頁' : '查看醫師目前預約網頁' }}</v-btn>-->
<!--                </div>-->
                <div
                  class="d-flex align-center px-4"
                  :style="$vuetify.breakpoint.mdAndUp ? 'width: auto;' : 'width: 100%;'"
                  :class="{ 'pb-3': $vuetify.breakpoint.smAndDown }"
                >
                  <v-menu
                    v-if="selectedItem && selectedItem !== 'clinic-wide'"
                    offset-y
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        block
                      >
                        {{ clinicUser ? '查看診所目前預約網頁' : '查看醫師目前預約網頁' }}
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item
                        v-for="channel in ['line', 'website', 'google']"
                        :key="channel"
                        :href="websiteUrl(channel)"
                        target="_blank"
                      >
                        <v-list-item-title>{{ getChannelLabel(channel) }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>

              </div>
            </div>
            <v-card-text>
              <v-container fluid>
                <div v-if="selectedItem === 'clinic-wide'" class="d-flex flex-column" style="gap: 24px;">
                  <clinic-wide-appointment-setting @loaded="onClinicWideSectionLoaded" />
                  <slot-closure-setting ref="slotClosure" @loaded="onClinicWideSectionLoaded" />
                  <online-reserve-submit-message-setting />
                </div>

                <v-row v-else>
                  <v-col v-if="slotClosedDates.length" cols="12">
                    <div class="slot-closure-banner d-flex align-center flex-wrap">
                      <span>{{ slotClosedDatesText }}已關閉空檔</span>
                      <a
                        v-if="clinicUser"
                        href="#"
                        class="ml-auto tiffany-8--text"
                        @click.prevent="goToSlotClosure"
                      >前往修改</a>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <mode-choice
                      v-if="selectedItem"
                      :setting-code="selectedItem"
                      :card-text-style="cardTextStyle"
                      :client-permissions="clientPermissions"
                      @saving-change="modeSettingSaving = $event"
                    />
                  </v-col>
                  <v-col cols="12" md="8">
                    <setting-detail
                      v-if="selectedItem"
                      :setting-code="selectedItem"
                      :card-text-style="cardTextStyle"
                      :client-permissions="clientPermissions"
                      @navigate-clinic-wide="selectedItem = 'clinic-wide'"
                    />
                  </v-col>
                  <v-col cols="12">
                    <manual-setting
                      v-if="selectedItem && canShow([3], clientPermissions, modeSetting)"
                      :setting-code="selectedItem"
                      :slot-closed-dates="slotClosedDates"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { mapGetters } from "vuex";
import ModeChoice from "@/components/OnlineAppointmentsSetting/ModeChoice.vue";
import { getClinicListAPI, getDoctorListAPI, getInfoAPI, getSlotClosuresAPI } from "@/api";
import SettingDetail from "@/components/OnlineAppointmentsSetting/SettingDetail.vue";
import ManualSetting from "@/components/OnlineAppointmentsSetting/ManualSetting.vue";
import ClinicWideAppointmentSetting from "@/components/OnlineAppointmentsSetting/ClinicWideAppointmentSetting.vue";
import OnlineReserveSubmitMessageSetting from "@/components/OnlineAppointmentsSetting/OnlineReserveSubmitMessageSetting.vue";
import SlotClosureSetting from "@/components/OnlineAppointmentsSetting/SlotClosureSetting.vue";
import { canShow } from "@/utils/tool";
import { closedDatesForDoctor, formatClosureDate } from "@/utils/slotClosure";
import GuideTour from "@/components/utils/GuideTour.vue";

export default {
  name: "FreeTime",

  components: {
    GuideTour,
    ManualSetting,
    SettingDetail,
    ModeChoice,
    Navigation,
    ClinicWideAppointmentSetting,
    OnlineReserveSubmitMessageSetting,
    SlotClosureSetting
  },

  data() {
    return {
      selectedItem: null,
      tabItems: [],
      info: null,
      clientPermissions: [],
      modeSettingSaving: false,
      slotClosureUpcoming: [],
      slotClosureRequestId: 0,
      slotClosureScrollWaitingFor: 0,
      canShow
    }
  },

  computed: {
    ...mapGetters([
      'liffUser',
      'clinicUser',
      'axiosParamData',
      'modeSetting',
    ]),
    cardTextStyle() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return `min-height: 366px; height: 366px; max-height: 366px; gap: 26px;`
      } else {
        return `gap: 18px;`
      }
    },
    slotClosedDates() {
      const doctorCode = this.clinicUser ? this.selectedItem : this.axiosParamData.doctor_code
      return closedDatesForDoctor(this.slotClosureUpcoming, doctorCode)
    },
    slotClosedDatesText() {
      return this.slotClosedDates.map(formatClosureDate).join('、')
    },
  },

  watch: {
    selectedItem: {
      async handler(v) {
        if (v) {
          if (v !== 'clinic-wide') {
            this.slotClosureScrollWaitingFor = 0
            this.fetchSlotClosures(v)
          }
          if (!this.info) await this.getInfo()
          this.setClientPermission()
        }
      }
    }
  },

  methods: {
    setClientPermission() {
      if (this.selectedItem === 'clinic-wide') {
        this.clientPermissions = this.info ? [...this.info.permission_name] : []
        return
      }
      let key
      if (this.clinicUser) {
        key = 'doctors'
      } else {
        key = 'clinics'
      }
      const secObj = this.info[key].find(sub => sub.code === this.selectedItem)
      this.clientPermissions = [...this.info.permission_name, ...secObj.permission_name]
    },
    async getInfo() {
      const res = await getInfoAPI(this.axiosParamData)
      this.info = res.data
    },
    // 只是標示，讀不到時不擋頁面操作；切換診所時舊回應不能蓋掉新的
    async fetchSlotClosures(settingCode) {
      const requestId = ++this.slotClosureRequestId
      const params = { ...this.axiosParamData }
      if (!this.clinicUser) {
        params.clinic_code = settingCode
        this.slotClosureUpcoming = []
      }
      try {
        const { data } = await getSlotClosuresAPI(params)
        if (requestId === this.slotClosureRequestId) this.slotClosureUpcoming = data.upcoming
      } catch (e) {
        console.error(e)
      }
    },
    // 全院分頁的兩個區塊都載完版面才定型，太早捲動會被後來長高的內容推出畫面
    goToSlotClosure() {
      this.slotClosureScrollWaitingFor = 2
      this.selectedItem = 'clinic-wide'
    },
    onClinicWideSectionLoaded() {
      if (!this.slotClosureScrollWaitingFor) return
      this.slotClosureScrollWaitingFor -= 1
      if (this.slotClosureScrollWaitingFor) return
      this.$nextTick(() => {
        this.$refs.slotClosure.$el.scrollIntoView({ block: 'start' })
      })
    },
    // websiteUrl() {
    //   let doctorCode, clinicCode
    //   if (this.clinicUser) {
    //     doctorCode = this.selectedItem
    //     clinicCode = this.axiosParamData.clinic_code
    //     return `https://www.dentco.tw/appointment/clinic/${clinicCode}?type=clinic&doctorCode=${doctorCode}`
    //   } else {
    //     doctorCode = this.axiosParamData.doctor_code
    //     clinicCode = this.selectedItem
    //     return `https://www.dentco.tw/appointment/doctor/${doctorCode}?type=doctor&clinicCode=${clinicCode}`
    //   }
    // },
    websiteUrl(channelKey) {
      let doctorCode, clinicCode
      const channelMapping = {
        line: 'line',
        website: '',
        google: 'Reserve-with-Google'
      };
      const channel = channelMapping[channelKey];
      if (this.clinicUser) {
        doctorCode = this.selectedItem
        clinicCode = this.axiosParamData.clinic_code
        return `https://www.dentco.tw/appointment/clinic/${clinicCode}?type=clinic&doctorCode=${doctorCode}&channel=${channel}`
      } else {
        doctorCode = this.axiosParamData.doctor_code
        clinicCode = this.selectedItem
        return `https://www.dentco.tw/appointment/doctor/${doctorCode}?type=doctor&clinicCode=${clinicCode}&channel=${channel}`
      }
    },
    getChannelLabel(channel) {
      switch (channel) {
        case 'line': return 'LINE 預約頁面'
        case 'website': return '跨網頁預約頁面'
        case 'google': return 'Google 地圖預約頁面'
        default: return '預約頁面'
      }
    }
  },

  mounted() {
    if (this.clinicUser) {
      getDoctorListAPI(this.axiosParamData).then(res => {
        const doctorTabs = res.data.map(e => ({
          name: e.doctor_name,
          code: e.doctor_code
        }))
        this.tabItems = [
          { name: '全院線上預約設定', code: 'clinic-wide' },
          ...doctorTabs
        ]
        if (this.$route.query.section === 'slot-closure') {
          this.goToSlotClosure()
        } else if (doctorTabs.length > 0) {
          this.selectedItem = doctorTabs[0].code
        }
      })
    } else {
      getClinicListAPI(this.axiosParamData).then(res => {
        this.tabItems = res.data.map(e => {
          return {
            name: e.clinic_name,
            code: e.clinic_code
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.slot-closure-banner {
  gap: 4px 14px;
  padding: 12px 16px;
  border-radius: 4px;
  background: var(--v-tiffany-11-base);
  color: var(--v-tiffany-8-base);
}
</style>
